/*
 * 项目基础信息组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import CNF from '../../incs/Config.js';
import {
    Flex,
    Modal,
    Button,
} from 'antd';
import {
    Html2pdf,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper.js';


/***
 * 打印工单
 */
const WOInfo = (props) => {
    const { open, setOpen, record, preGroup, btnLists } = props;

    const cancel = () => { setOpen(false); }

    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', record.number, ''); };


    return (
        <>
            <Modal
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                width={820}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='submit' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: '24px' }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Flex justify='space-between' style={{ marginBottom: '10px' }}>
                            <img src={BrandUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                            <img src={SloganUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                        </Flex>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24' ><h2>项目基础信息</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目编号:</td><td colSpan='20' style={{ width: 600 }}>{record.number}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目名称:</td><td colSpan='20' style={{ width: 600 }}>{record.name}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>项目区域:</td><td colSpan='20' style={{ width: 600 }}>{record.area}</td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>项目类型:</td><td colSpan='8' style={{ width: 240 }}>{record.type}</td>
                                    <td colSpan='4' style={{ width: 120 }}>项目阶段:</td><td colSpan='8' style={{ width: 240 }}>{record.phase}</td>
                                </tr>
                                {
                                    btnLists && btnLists.indexOf('btn_plms_om') >= 0 ? <tr><td colSpan='4' style={{ width: 120 }}>维护内容:</td><td colSpan='20' style={{ width: 600 }}>
                                        {record.maintenance_content && record.maintenance_content.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr> : ''
                                }

                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='20' style={{ width: 600 }}>
                                    {record.description && record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default WOInfo;